






















































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import ProfileConnector from '@/connector/Profile.vue';
import moment from 'moment';
import TransactionService from '@/services/TransactionService';

const transactionService = new TransactionService();

@Component({
  components: {
    ProfileConnector,
  },
})
export default class RefundLossDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public loading: boolean = false;

  public isAlreadyRedeem: boolean = false;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  get previousWeek() {
    return `${moment().subtract(1, 'week').week()}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get currentYear() {
    return moment().year();
  }

  // eslint-disable-next-line class-methods-use-this
  get weekRange() {
    const previousWeek = moment().subtract(1, 'week');
    return `${previousWeek.startOf('week').format('YYYY-MM-DD')},${previousWeek.endOf('week').format('YYYY-MM-DD')}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get isAvailableToRedeem() {
    const today = moment().format('YYYY-MM-DD');
    const dayToRedeem = moment().startOf('week').format('YYYY-MM-DD');
    return today === dayToRedeem;
  }

  async refundLoss() {
    this.loading = true;
    try {
      await transactionService.refundLoss();
      this.loading = false;
      this.$store.dispatch('Dialog/updateDialog', { open: false, dialogType: '' });
      this.$store.commit('Snackbar/showNotification', { message: 'รับยอดเสียคืนสำเร็จ', error: false });
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
      this.loading = false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  calculateLoss(withdrawSum: number, depositSum: number) {
    const gain = withdrawSum - depositSum;
    if (gain > 0) return 0;
    return Math.abs(gain * 0.03).toFixed(2);
  }

  async created() {
    try {
      const { data } = await transactionService.getRefundLoss();
      console.log(data);
      if (data.result) {
        this.isAlreadyRedeem = true;
      }
    } catch (e) {
      console.log(e);
    }
  }
}
